import { SxProps, Theme } from '@mui/material';
import { t } from 'i18next';

import { spacing } from '~theme/AppTheme';

type LoadsTableColumn = {
  key: string;
  size: string;
  sx?: SxProps<Theme>;
  title?: string;
};

export const columns: LoadsTableColumn[] = [
  {
    key: 'number',
    title: `${t('approvals.files.loads_table.headers.number')}`,
    size: `calc(30px + ${spacing(2)})`,
    sx: { p: 1, overflow: 'hidden', textAlign: 'center' },
  },
  {
    key: 'status_and_cycle',
    title: `${t('approvals.files.loads_table.headers.status_and_cycle')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'ticket',
    title: `${t('approvals.files.loads_table.headers.ticket')}`,
    size: '2fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'quantity',
    title: `${t('approvals.files.loads_table.headers.quantity')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'material',
    title: `${t('approvals.files.loads_table.headers.material')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'phase',
    title: `${t('approvals.files.loads_table.headers.phase')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'ticket_time',
    title: `${t('approvals.files.loads_table.headers.ticket_time')}`,
    size: '0.75fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'created',
    title: `${t('approvals.files.loads_table.headers.created')}`,
    size: '0.75fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'pickup_and_dropoff',
    title: `${t('approvals.files.loads_table.headers.pickup_and_dropoff')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'pickup_time',
    title: `${t('approvals.files.loads_table.headers.pickup_time')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'dropoff_time',
    title: `${t('approvals.files.loads_table.headers.dropoff_time')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'actions',
    size: `calc(150px + ${spacing(2)})`,
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'delete_load',
    size: `calc(16px + ${spacing(2)})`,
    sx: { p: 1, overflow: 'hidden' },
  },
];

export const gridTemplateColumns = columns.map((column) => column.size).join(' ');
